import cx from 'classnames';
import Link from "next/link";
import useLinkProps from "../../../hooks/use-link-props";
import useTranslation from "next-translate/useTranslation";
import BPImage from "../../ui/v2/image";
import Chevrelon from '../../ui/icons/cheverlon';
import Trans from 'next-translate/Trans';
import FeaturedLink from '../../ui/links/featured';


const EcoRepairScoreModule = ({ isPLP = false }) => {
    const { t } = useTranslation();
    const getLink = useLinkProps();

    return <>
        <Link {...getLink('eco-repair-score', undefined)} passHref legacyBehavior >
            <FeaturedLink
                variant="neutral"
                className="text-neutral-80"
                target="_blank"
            >
                <div className='border border-eco-repair-A rounded-sm bg-white hover:bg-brand-10 cursor-pointer'>
                    <div className={cx('grid max-lg:p-[12px] px-6 py-4 gap-4 lg:gap-6',
                        isPLP ? 'grid-cols-[55px_1fr]' : 'grid-cols-[55px_1fr] lg:grid-cols-[83px_1fr]'
                    )}>
                        <div className={cx('relative w-full',
                            isPLP ? 'w-[55px]' : 'w-[55px] lg:w-[83px]'
                        )}>
                            <BPImage
                                src={'/img/eco_repair_logo_horizontal.jpeg'}
                                alt="image"
                                layout="fill"
                                objectFit="contain"
                                objectPosition="right"
                                className={cx(
                                    'bg-blend-multiply w-full '
                                )}
                            />
                        </div>
                        <div className={cx('justify-between items-center flex flex-row gap-4 w-full')}>
                            <div className='flex items-center flex-row gap-4'>
                                <span className={cx({
                                    'text-[20px] lg:text-[32px] font-bold': !isPLP,
                                    'hidden': isPLP
                                })}>{t('eco-repair:smallEcoRepairSection.co2Saved')}</span>
                                <span className='text-base'>
                                    <Trans
                                        i18nKey={isPLP ? "eco-repair:smallEcoRepairSection.titlePLP" : "eco-repair:smallEcoRepairSection.title"}
                                        components={{
                                            b: <b></b>
                                        }} />
                                </span>
                            </div>

                            <div className='flex items-center justify-center py-4'>
                                <Chevrelon className="text-neutral-80 h-4 w-4 font-bold -rotate-90"></Chevrelon>
                            </div>
                        </div>

                    </div>

                </div>
            </FeaturedLink>
        </Link >
    </>;
}

export default EcoRepairScoreModule;